import React, { useRef } from 'react';
import { MdColorLens } from 'react-icons/md';
import './ColorPicker.css';

function ColorPicker({ value, onChange, label, required = false }) {
  const inputRef = useRef(null);

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  return (
    <div className="colorpicker-wrapper">
      {label && (
        <label className="colorpicker-label">
          {label}
          {required && <span className="required-mark">*</span>}
        </label>
      )}
      
      <div className="colorpicker-container" onClick={handleClick}>
        <div className="colorpicker-icon">
          <MdColorLens size={20} />
        </div>
        
        <div className="colorpicker-display">
          <div 
            className="color-preview" 
            style={{ backgroundColor: value || '#10243C' }}
          />
          <span className="color-value">{value || '#10243C'}</span>
        </div>

        <input
          ref={inputRef}
          type="color"
          value={value || '#10243C'}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          className="colorpicker-input"
        />
      </div>
    </div>
  );
}

export default ColorPicker;
